<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        <div class="manager-title-custom">{{ title }}</div>
        <!-- <div class="note">(*) Nội dung không được bỏ trống</div> -->
        <formView 
          v-if="mode=='view'"
          :key="componentKey"
          :mode="mode"
          @back="backToList"
          @save="saveData"
          :model="models"/>
        <formEdit
          v-if="mode!=='view'"
          :key="componentKey"
          :mode="mode"
          @back="backToList"
          @save="saveData"
          :model="models"/>
      </div>
    </div>
  </div>
</template>

<script>
// import Config from '../../../config/index'
import formEdit from './add'
import formView from './view'
import ApiRepository from "@/core/ApiRepository";
export default {
  components: {
    formEdit,
    formView
  },
  data() {
    return {
      users: null,
      validationErrors: [],
      title: "Thêm Hồ Sơ",
      mode: 'add',
      models: {},
      componentKey: 0,
      page_transaction:null,
      company_id: null
    }
  },
  async mounted () {
    var daily_atw_sample_license_id = null;
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.company_id)){
        this.company_id = this.$route.query.company_id;
      }
      if (!this.$commonFuction.isEmpty(this.$route.query.tp)){
        if(this.$route.query.tp == 'edit'){
          this.mode = 'edit'
          this.title = 'Cập nhật hồ sơ'
        }else if(this.$route.query.tp=='view'){
          this.mode = 'view'
          this.title = 'Xem hồ sơ'
        }
      }
      if (!this.$commonFuction.isEmpty(this.$route.query.dasl_id)){
        daily_atw_sample_license_id = this.$route.query.dasl_id;
      }  
    }
    if (this.$route.params.id !== undefined) {
      await this.getData(this.$route.params.id,daily_atw_sample_license_id);
    }
    
  },
  methods: {
    backToList() {
      if(this.$route.params.id){
        var query = {
          company_id: this.company_id
        }
        query.ctab = 1;
        this.$router.push({ path: '/admin/daily-atw/view/'+this.$route.params.id, query: query });
      }else{
        this.$router.go(-1);
      }
    },
    async saveData(params) {
      console.log("params",params)
      var that = this;
      let objects = {
        company_id: params?.company ? params.company.id : null,
        files_deleted : params.files_deleted ?? [],
        list_profile : params.list_profile ?? [],
        note : params.note,
        files_deleted_root : params.files_deleted_root,
        daily_atw_sample_license_id : params.daily_atw_sample_license_id,
      }
      objects.id = this.$route.params.id;
      this.company_id = params?.company ? params.company.id : null;
      var token = that.$store.getters.token ? that.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        
          await ApiRepository.post("/_api/daily_atw/update_profile", objects, {headers}).then(async function (response) {
            if (response.status === 200) {
                that.redirectEdit(params.type);
            } else {
              that.$toast.add({
                  severity: 'error',
                  summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                  detail: response.data.message,
                  life: 3000
              });
              that.$commonFuction.is_loading(false);
            }
          }).catch((err) => {
            console.log('errorerrorerrorerror', err);
            that.$toast.add({
                severity: 'error',
                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: err,
                life: 3000
            });
            that.$commonFuction.is_loading(false);
          })
       
      }
    },
    async redirectEdit() {
      if(this.$route.params.id){
        var query = {
          company_id: this.company_id
        }
        query.ctab = 1;
        this.$commonFuction.is_loading(false);
        this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Lưu dữ liệu thành công', life: 3000 })
        this.$router.push({ path: '/admin/daily-atw/view/'+this.$route.params.id, query: query });
      }else{
        this.$router.go(-1);
      }
      // var that = this;
      // var router_back = {path: '/admin/daily-atw/view/'+this.$route.params.id};
      // that.$commonFuction.is_loading(false);
      // if(that.mode == 'add'){
      //   router_back.query = {company_id: this.company_id};
      //   that.$router.push(router_back);
      // }else{
      //   if (!that.$commonFuction.isEmpty(router_back)){
      //     // that.page_transaction = ""+that.page_transaction
      //     router_back.query = {company_id: this.company_id };
      //   }
      //   that.$router.push(router_back);
      // }
      // that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Lưu dữ liệu thành công', life: 3000 })
    },
    async getData(id,daily_atw_sample_license_id=null) {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var {data} = await ApiRepository.post("/_api/daily_atw/detail_normal", {id: id,daily_atw_sample_license_id : daily_atw_sample_license_id, company_id: this.company_id}, {headers});
        var value = data.data;
        this.models = value;
        if(value.daily_atw_sample_license && value.daily_atw_sample_license.sample_license){
          this.title = 'Cập nhật hồ sơ - ' +value.daily_atw_sample_license.sample_license.name;
        }
        this.componentKey++;
      }
    },
  },
}
</script>

<style lang="scss">
  .manager-title-custom{
    color: #1D3118;
    font-size: 18px;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #EEEEEE;
    font-weight: 700;
  }
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
.p-formgrid { margin: 0;
  .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
  .p-card-field{ padding: 24px;
    .p-field{
      .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
      .p-col-width{width:500px !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;  resize: none;}
      }
      .box-images{ margin: 0; margin-top: 10px; position: relative;
        .item-img{width: 133px; height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative;
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain; padding: 5px;}
          .button-clear{border-radius: 5px; width: 24px; height: 24px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }
  .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 22px; border-top: 1px solid #B4B4B4; padding: 0; padding-top: 30px;
    .p-button{width: auto; margin-right: 8px;
      &:last-child{margin-right: 0;}
    }
  }
}
</style>

